import React from 'react';
import PropTypes from 'prop-types';

import FilterSet from 'components/Explorer/models/filter_set';
import ModalPicker from 'components/Explorer/AdvancedSearch/ModalPicker';
import createOutputCount from 'components/Explorer/AdvancedSearch/ModalPicker/outputCount';

const outputCount = createOutputCount('funders');

const FunderPickerFilter = ({ filterSet, initialSearch }) => (
  <ModalPicker
    filterSet={filterSet}
    initialSearch={initialSearch}
    i18nKey="funders"
    filterKey="funders[]"
    autocompletePath="/explorer/json_data/funders/search"
    childrenPath="/explorer/json_data/funders/children"
    bootstrapMethod="funders"
    analyticsDialogueName="Funder"
    maxSelected={null}
    helperText={[
      I18n.t('Explorer.AdvancedSearch.fields.funders.modal.helper_source'),
      I18n.t('Explorer.AdvancedSearch.fields.funders.modal.helper_coverage')
    ]}
    renderResultExtras={outputCount}
  />
);

FunderPickerFilter.propTypes = {
  filterSet: PropTypes.instanceOf(FilterSet).isRequired,
  initialSearch: PropTypes.string
};

export default FunderPickerFilter;
